import React from "react";

const CtaSection = () => {

    return (
        <>
            <section className="cta-section">

                {/* Animated Background */}
                <div className="cta-bg-grid"></div>

                <div className="cta-glow cta-glow-1"></div>
                <div className="cta-glow cta-glow-2"></div>

                {/* Floating Elements */}
                <div className="floating-circle circle-1"></div>
                <div className="floating-circle circle-2"></div>
                <div className="floating-circle circle-3"></div>

                <div className="cta-container">

                    {/* Left Content */}
                    <div className="cta-left">

                        <span className="cta-badge">
                            LET'S BUILD YOUR APP
                        </span>

                        <h2>
                            Turn Your
                            <span> App Idea</span>
                            <br />
                            Into Reality.
                        </h2>

                        <p>
                            From concept to launch — we craft high-performance
                            iOS, Android & cross-platform mobile apps that
                            users love and businesses grow with.
                        </p>

                        {/* Features */}
                        <div className="cta-features">

                            <div className="cta-feature">
                                <div className="feature-dot"></div>
                                <span>UI/UX Design</span>
                            </div>

                            <div className="cta-feature">
                                <div className="feature-dot"></div>
                                <span>iOS & Android Apps</span>
                            </div>

                            <div className="cta-feature">
                                <div className="feature-dot"></div>
                                <span>Launch Support</span>
                            </div>

                        </div>

                        {/* Buttons */}
                        <div className="cta-buttons">

                            <button className="cta-primary-btn">
                                Start Your Project
                                <span>→</span>
                            </button>

                            <button className="cta-secondary-btn">
                                View Portfolio
                            </button>

                        </div>

                    </div>

                    {/* Right Side */}
                    <div className="cta-right">

                        {/* Main Card */}
                        <div className="cta-card">

                            <div className="card-header">

                                <div className="card-logo">
                                    AV
                                </div>

                                <div>
                                    <h4>AppVerseLabs</h4>
                                    <span>App Development Studio</span>
                                </div>

                            </div>

                            {/* Progress */}
                            <div className="card-progress">

                                <div className="progress-top">
                                    <span>App Development Progress</span>
                                    <span>92%</span>
                                </div>

                                <div className="progress-bar">
                                    <div className="progress-fill"></div>
                                </div>

                            </div>

                            {/* Stats */}
                            <div className="card-stats">

                                <div className="stat-box">
                                    <h5>150+</h5>
                                    <p>Apps Delivered</p>
                                </div>

                                <div className="stat-box">
                                    <h5>4.9★</h5>
                                    <p>Client Rating</p>
                                </div>

                            </div>

                            {/* Bottom */}
                            <div className="card-bottom">

                                <div className="bottom-dot"></div>

                                <span>
                                    Available for New Projects
                                </span>

                            </div>

                        </div>

                        {/* Floating Mini Cards */}

                        <div className="mini-card mini-1">
                            🚀 Fast Launch
                        </div>

                        <div className="mini-card mini-2">
                            📱 Modern UI/UX
                        </div>

                        <div className="mini-card mini-3">
                            ⚡ High Performance
                        </div>

                    </div>

                </div>

            </section>
        </>
    );
};

export default CtaSection;